import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Suppliers } from '../../components/economicsphere/ui/Suppliers'; 
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const SuppliersPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Поставщики</title>
            </Helmet>
            <Suppliers/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default SuppliersPage
